export const calculateMonthlyPayment = ({
  totalLoanAmount,
  interestRate,
  amortizationTerm,
  amortizationType
}: {
  totalLoanAmount: number;
  interestRate: number;
  amortizationTerm?: number;
  amortizationType: 'Interest Only' | 'Fully Amortizing';
}) => {
  const monthlyInterestRate = interestRate / 100 / 12;
  if (amortizationType === 'Interest Only') {
    return totalLoanAmount * monthlyInterestRate;
  } else {
    const numberOfPayments = amortizationTerm ? amortizationTerm : 1;
    const monthlyPayment =
      (totalLoanAmount *
        monthlyInterestRate *
        Math.pow(1 + monthlyInterestRate, numberOfPayments)) /
      (Math.pow(1 + monthlyInterestRate, numberOfPayments) - 1);
    return monthlyPayment;
  }
};
